import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Sl1AnagrafService} from '../../../general-services/service-sl1-services/sl1-anagraf.service';
import * as toastr from 'toastr';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';

@Component({
  selector: 'app-edit-design-services-anagraf',
  templateUrl: './edit-sl1-anagraf.component.html',
  styleUrls: ['./edit-sl1-anagraf.component.scss']
})
export class EditSl1AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  designServices: DesignServicesModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  id: number;
  designServicesCod: string;
  designServiceJson: any;
  description: any;
  submitted: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private sl1AnagrafService: Sl1AnagrafService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.designServiceJson = params['row'];
      });

    this.designServices = new DesignServicesModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.designServices = JSON.parse(this.designServiceJson) as DesignServicesModel;

    this.formValidator.patchValue({
      cod: this.designServices ? this.designServices.cod : ''
    });

    this.formValidator.patchValue({
      description: this.designServices ? this.designServices.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.designServicesCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL1_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.designServices.cod = this.formValidator.controls['cod'].value;
      this.designServices.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.sl1AnagrafService.update(this.sl1AnagrafService.baseUrl, this.designServices).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL1 Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('SL1 was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL1_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
